import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import { GlobalsService } from 'src/app/services/globals/globals.service';
import { checkServerIdentity } from 'tls';
var sha256 = require('js-sha256');

@Component({
  selector: 'app-gatekeeper',
  templateUrl: './gatekeeper.component.html',
  styleUrls: ['./gatekeeper.component.scss'],
})
export class GatekeeperComponent implements OnInit {
  @ViewChild('checkboxTandC') private checkboxTandC: MatCheckbox;

  public loginBusy: boolean = false;
  public activeForm: 'loginForm' | 'signupForm' = 'loginForm';
  public loggedIn: boolean = false;
  public awaitRetrieve: boolean = true;

  //#region  : setup form controls

  nameFormControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(2),
  ]);

  surnameFormControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(2),
  ]);

  phoneFormControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(10),
  ]);

  emailFormControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  passwordFormControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(8),
  ]);

  passwordRetypeFormControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(8),
    Validators.pattern(this.passwordFormControl.value),
  ]);

  public hidePW1: boolean = true;
  public hidePW3: boolean = true;
  public hidePW2: boolean = true;

  //#endregion

  constructor(
    public globals: GlobalsService,
    private api: ApiService,
    private router: Router,
    private _snackBar: MatSnackBar
  ) {
    //Check logged in?
    //Check last path and clear
  }

  ngOnInit() {
    this.api.retrieve(
      () => {
        let prev = localStorage.getItem('lastpage');
        this.loggedIn = true;
        this.globals.directRouting = true;

        if (prev && prev == 'devicelist') {
          this.globals.currentview = 'app';
          this.globals.selectedRoute = 'devicelist';
          this.router.navigate(['devicelist']);
        } else {
          this.globals.selectedRoute = 'dashboard';
          this.globals.currentview = 'app';
          this.router.navigate(['dashboard']);
        }
      },
      () => {
        this.globals.selectedRoute = 'dashboard';
        this.globals.currentview = 'login';

        // this.router.navigate(['dashboard']);
        //Show activation result maybe
        if (this.globals.showActivation) {
          setTimeout(() => {
            // window.location.href = this.removeParams("key");
            let mes = this.globals.activationResult
              ? 'User activation successful'
              : 'User activation failed';
            let format = this.globals.activationResult
              ? 'black-snackbar'
              : 'red-snackbar';
            this._snackBar.open(mes, 'OK', {
              duration: 5000,
              panelClass: [format],
            });
          }, 2000);
        }
      }
    );
  }
  removeParams(sParam) {
    var url = window.location.href.split('?')[0] + '?';
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] != sParam) {
        url = url + sParameterName[0] + '=' + sParameterName[1] + '&';
      }
    }
    return url.substring(0, url.length - 1);
  }

  sendRecoveryEmail(email: string) {
    if (this.emailFormControl.value && this.emailFormControl.value != '') {
      this.api.forgotPassword(
        this.emailFormControl.value,
        (res: any) => {
          // console.log(res);
          if (res && res.accepted && res.accepted.length > 0)
            this._snackBar.open(
              `We sent a recovery email to ${res.accepted[0]}`,
              'Close'
            );
        },
        () => {
          this._snackBar.open(`User not found`, '', { duration: 3000 });
        }
      );
    } else {
      this._snackBar.open(`Please enter an email address`, '', {
        duration: 3000,
      });
    }
  }

  signInDisabled() {
    let retVal: boolean = true;

    if (
      !this.emailFormControl.hasError('email') &&
      !this.emailFormControl.hasError('required') &&
      !this.passwordFormControl.hasError('required') &&
      !this.passwordFormControl.hasError('minlength')
    ) {
      retVal = false;
    }

    return retVal;
  }

  signUpDisabled() {
    let retVal: boolean = true;

    //Make sure Ts&Cs box is checked
    let checkbox = document.getElementById('checkboxTandC');
    let checked = checkbox.className.includes('mat-checkbox-checked');

    if (
      !this.nameFormControl.hasError('required') &&
      !this.emailFormControl.hasError('required') &&
      !this.passwordFormControl.hasError('required') &&
      !this.passwordFormControl.hasError('minlength') &&
      checked
    ) {
      retVal = false;
    }

    return retVal;
  }

  doLogin() {
    //Do field validation
    this.loginBusy = true;

    //Do Login
    //Login with no credentials to check if session already exists
    this.globals.selectedRoute = 'dashboard';
    this.api.login(
      this.emailFormControl.value,
      this.passwordFormControl.value,
      () => {
        //Login successful
        this.loginBusy = false;

        //Navigate to dashboard
        this.globals.currentview = 'app';
        this.router.navigate(['dashboard']);
      },
      (res?: boolean) => {
        //Login failed
        this.loginBusy = false;
        //Show error

        //Show login screen
        this.globals.currentview = 'login';

        //Show error
        this._snackBar.open(`Login failed. Please try again.`, '', {
          duration: 3000,
        });

        // this.globals.currentview = "app"
        // this.router.navigate(['dashboard']);
      }
    );
  }

  doSignup() {
    let me = this;

    //Get data
    let name = this.nameFormControl.value;
    let surname = this.surnameFormControl.value;
    let phone = this.phoneFormControl.value;
    let email = this.emailFormControl.value;
    let password = this.passwordFormControl.value;
    let retypepassword = this.passwordRetypeFormControl.value;

    if (password == retypepassword) {
      var hash = sha256.create();
      hash.update(this.passwordFormControl.value);

      this.api.register(
        name,
        email,
        email,
        password,
        surname,
        undefined,
        phone,
        undefined,
        undefined,
        () => {
          //Success
          // console.log('success');

          //Show email was sent
          this._snackBar.open(
            `Please activate your account by following the link in the email sent to: ${email}`,
            '',
            { duration: 5000 }
          );
        },
        (res: boolean, reason: string) => {
          //Failure
          // console.log('failure');

          if (res && reason == 'RESEND_ACTIVATION') {
            let sb = this._snackBar.open(
              `Account exists, but not activated. Resend activation to ${me.emailFormControl.value}`,
              '',
              { duration: 5000 }
            );

            sb.onAction().subscribe(() => {
              //Resend activation link
              this.api.register_resend(me.emailFormControl.value);
            });
          }
        }
      );
    } else {
      //Passwords doesn't match
    }
  }

  switchActiveScreen(to: 'signup' | 'login') {
    this.activeForm = to == 'signup' ? 'signupForm' : 'loginForm';
  }

  showPrivacyPolicy() {
    //TODO
  }

  selectCheckText(event) {
    // console.log(event);
    event.preventDefault();
    event.stopPropagation();
  }

  showTsAndCs() {
    //TODO
  }

  keyDownFunction(event) {
    if (event.keyCode === 13) {
      // alert('you just pressed the enter key');
      // rest of your code
      this.doLogin();
    }
  }
}
